import { Box, Grid, GridItem, Icon, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { FaCar, FaUser, FaFileInvoiceDollar } from "react-icons/fa";
import BreadCrumbMaker from "../../../../components/BreadCrumbMaker";

const ViewPendingDriversRequests = () => {
  const cardData = [
    {
      id: 1,
      title: "PENDING FLEETS",
      icon: FaCar,
      link: "/management/pending-requests/fleets",
      bgColor: "#ffe3f3",
      color: "#ff77c0",
    },
    {
      id: 2,
      title: "PENDING DRIVERS",
      icon: FaUser,
      link: "/management/pending-requests/drivers",
      bgColor: "#ece9ff",
      color: "#8c84ff",
    },
    {
      id: 3,
      title: "PENDING VENDORS",
      icon: FaFileInvoiceDollar,
      link: "/management/pending-requests/vendors",
      bgColor: "#ffe9e2",
      color: "#ff8542",
    },
  ];

  return (
    <Box px={4} py={6}>
      <BreadCrumbMaker
        items={[
          { link: "/", title: "Dashboard" },
          { link: "/management", title: "Operations Setup", on: true },
        ]}
      />
      <Grid
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
        }}
        gap={6}
      >
        {cardData.map((card) => (
          <GridItem key={card.id}>
            <Link to={card.link}>
              <Box
                bg="white"
                p={4}
                rounded="md"
                shadow="md"
                textAlign="center"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                h="200px"
                gap={2}
              >
                <Box
                  bg={card.bgColor}
                  w={12}
                  h={12}
                  mx="auto"
                  mb={4}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius={4}
                >
                  <Icon as={card.icon} boxSize={6} color={card.color} />
                </Box>
                <Text fontSize="lg" fontWeight="bold" color="gray.700">
                  {card.title}
                </Text>
              </Box>
            </Link>
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
};

export default ViewPendingDriversRequests;
